export const language: any = {
  title: "ชุมชน Hey! Cooker",
  follow: "ติดตาม",
  follower: "ผู้ติดตาม",
  post_share: "โพสต์ที่แชร์",
  like_share: "ถูกใจ",
  report: "รายงานการละเมิด",
  delete_post: "ลบโพสต์",
  delete_comment: "ลบความคิดเห็น",
  confirm_report: "คุณแน่ใจหรือว่าโพสต์นี้มีเนื้อหาที่ละเมิดหลักเกณฑ์ชุมชน? หลังจากรายงานสำเร็จ คุณจะไม่เห็นโพสต์นี้อีก",
  confirm_report_comment: "คุณแน่ใจหรือว่าความคิดเห็นนี้ละเมิดหลักเกณฑ์ชุมชน?",
  toats_report: "ขอบคุณที่รายงานการละเมิด รายงานของคุณกำลังได้รับการพิจารณา",
  confirm_delete: "คุณต้องการลบโพสต์นี้หรือไม่?",
  confirm_delete_comment: "คุณแน่ใจหรือว่าต้องการลบความคิดเห็นนี้?",
  toast_delete: "ลบสำเร็จแล้ว!",
  text_yes: "ใช่",
  text_no: "ไม่",
  create: {
    title: "สร้างโพสต์ - ชุมชน Hey!Cooker",
    content_placeholder: "กรอกเนื้อหาโพสต์ของคุณ",
    submit: "แชร์ตอนนี้",
    add_image_by_camera: "ถ่ายรูป",
    add_image_by_gallery: "เลือกภาพ",
    add_video_by_camera: "บันทึกวิดีโอ",
    add_video_by_gallery: "เลือกวิดีโอ",
  },
  detail: {
    shared: "แชร์แล้ว",
    shared_community: "แชร์รูปภาพ (วิดีโอ) กับชุมชน"
  },
  follwed: "ติดตามแล้ว",
  comment: {
    placeholder: "กรุณากรอกความคิดเห็น",
    submit: "ส่ง",
    nodata: "แสดงความคิดเห็นที่นี่และเป็นคนแรกที่แสดงความคิดเห็น!",
    load_more: "ดูความคิดเห็นเพิ่มเติม",
    not_login: "กรุณาเข้าสู่ระบบเพื่อแสดงความคิดเห็น",
    delete: "ลบความคิดเห็น",
    delete_confirm: "คุณแน่ใจหรือไม่ว่าต้องการลบความคิดเห็นนี้?",
    delete_success: "ลบความคิดเห็นเรียบร้อยแล้ว",
    report: "รายงาน",
    report_confirm: "คุณแน่ใจหรือไม่ว่าความคิดเห็นนี้ละเมิดหลักเกณฑ์ของชุมชน?",
    report_success: "ขอบคุณสำหรับการรายงาน\nรายงานของคุณอยู่ระหว่างการตรวจสอบ",
  },
  bottom_navigation: "ชุมชน",
  shared_post: "ได้แชร์โพสต์"
};

